import { extendedArea } from '@bpd-library/utilities';
import {
    AreaSubscriptionStatus,
    ExtendedAreaSubscriptionState,
} from '@features/area-subscription/types';
import { projectPhaseDefaultFilter } from '@features/area-subscription/utilities';
import { getSubscriptionState, isSubscriptionFormRequired } from '@store/subscription/store';

const getCurrentSubscriptionState = async (): Promise<ExtendedAreaSubscriptionState> => {
    const {
        areaProject,
        isUpdatedFromUserStore,
        projectPhases: subscribedProjectIds,
    } = getSubscriptionState();

    let status: AreaSubscriptionStatus;
    let areaSelected = false;

    const formRequiredState = isSubscriptionFormRequired();
    let formRequired: boolean;

    const { projectPhases: allProjectPhases } = await extendedArea.getData(
        window.__ENVIRONMENT_DETAILS__.areaId,
    );
    const projectPhases = allProjectPhases.filter(projectPhaseDefaultFilter);

    const availableProjectIds = projectPhases
        .filter(({ id }) => !subscribedProjectIds.includes(id))
        .map(({ id }) => id);

    if (!areaProject) {
        areaSelected = true;
        if (!projectPhases.length) {
            status = isUpdatedFromUserStore
                ? 'userNotSubscribedToAreaNoProjectsAvailable'
                : 'notSubscribedToAreaNoProjectsAvailable';

            formRequired = formRequiredState.area;
            return { status, formRequired, areaSelected };
        } else {
            status = isUpdatedFromUserStore ? 'userNotSubscribedToArea' : 'notSubscribedToArea';
            formRequired = formRequiredState.project;
            return { status, formRequired, areaSelected, availableProjectIds };
        }
    }

    if (!projectPhases.length) {
        status = 'subscribedToAreaNoProjectsAvailable';
        formRequired = formRequiredState.area;
        return { status, formRequired, areaSelected };
    }

    if (availableProjectIds.length === 0) {
        status = 'subscribedToAreaSubscribedToAllProjects';
    } else if (availableProjectIds.length === projectPhases.length) {
        status = 'subscribedToAreaNotSubscribedToProjects';
    } else {
        status = 'subscribedToAreaSubscribedToSomeProjects';
    }

    formRequired = formRequiredState.project;
    return { status, formRequired, areaSelected, subscribedProjectIds, availableProjectIds };
};

export { getCurrentSubscriptionState };
